module.exports = __webpack_public_path__ + "static/media/bg_img_p8_1.033015d8.png";